import React from 'react'

import { LoadingSpinner as Loading } from '@gousto-internal/citrus-react'
import type Immutable from 'immutable'
import { Helmet } from 'react-helmet'

import { BoostedRafSharing } from './BoostedRafSharing/BoostedRafSharing'
import { RafSharing } from './RafSharing/RafSharing'

import css from './Referral.css'

export type IRAFOffer = Immutable.Map<
  string,
  | string
  | string[]
  | { value: number; unit: string; formatted: string }
  | Immutable.Map<string, string>
  | Immutable.Map<string, IRAFOffer>
>
interface Props {
  device: string
  displayLink: string
  expiry?: string | null
  isLoading: boolean
  offerTitle: string
  rafOffer: IRAFOffer
  referralCode: string
  trackingReferFriend: () => void
  trackingReferFriendSocialSharing: () => void
  trackUserFreeFoodLinkShare: () => void
  userFirstName: string
  offerSubtitle?: string
}

export const ReferralPresentation: React.FC<Props> = ({
  device,
  displayLink,
  expiry,
  isLoading,
  offerTitle,
  rafOffer,
  referralCode,
  trackingReferFriend,
  trackingReferFriendSocialSharing,
  trackUserFreeFoodLinkShare,
  userFirstName,
  offerSubtitle,
}: Props) => {
  if (isLoading) {
    return (
      <div className={css.loadingContainer}>
        <Loading />
      </div>
    )
  }

  // boost view takes priority over non-boosted views - show this view when boost ui is enabled and expiry date
  if (expiry) {
    return (
      <div>
        <Helmet title="Gousto Referrals | Invite Your Friends To Try Gousto" />
        <div id="referral-code-box" className={css.containerBackgroundRafBoostRefreshUI}>
          <BoostedRafSharing
            rafOffer={rafOffer}
            expiry={new Date(expiry)}
            userRAFLink={displayLink}
            userFirstName={userFirstName}
            device={device}
            trackingReferFriendSocialSharing={trackingReferFriendSocialSharing}
            trackUserFreeFoodLinkShare={trackUserFreeFoodLinkShare}
            trackingReferFriend={trackingReferFriend}
            referralCode={referralCode}
          />
        </div>
      </div>
    )
  }

  return (
    <div>
      <Helmet title="Gousto Referrals | Invite Your Friends To Try Gousto" />
      <div id="referral-code-box">
        <RafSharing
          device={device}
          userRAFLink={displayLink}
          userFirstName={userFirstName}
          offer={rafOffer}
          offerTitle={offerTitle}
          referralCode={referralCode}
          trackingReferFriendSocialSharing={trackingReferFriendSocialSharing}
          trackUserFreeFoodLinkShare={trackUserFreeFoodLinkShare}
          trackingReferFriend={trackingReferFriend}
          offerSubtitle={offerSubtitle}
        />
      </div>
    </div>
  )
}
